export default __webpack_public_path__ + "static/media/icon-pencil.62ca016d.svg";